import { Button } from '@mzc-pdc/ui';
import React from 'react';
import { DialogButtonProps } from './infrastructures/DialogButtonProps';

export const ExecuteDialogButton = (props: DialogButtonProps) => {
  return (
    <Button
      disabled={props.disabled}
      onClick={props.onClick}
      color={'primary'}
      variant={'contained'}
    >
      {props.children}
    </Button>
  );
};
